module.exports = __webpack_public_path__ + "img/Logo-Daiteo-2.e9d29a5f.svg";